export const navLinks = [
  { href: "/", label: "Home" },
  {
    label: "Services",
    links: [
      {
        label: "Data Annotation",
        link: "/data-annotation",
      },
      {
        label: "Model Fine-tuning",
        link: "/model-fine-tuning",
      },
      {
        label: "Small Language Models (SLMs)",
        link: "/small-language-models",
      },
      {
        label: "Computer Vision",
        link: "/computer-vision",
      },
    ],
  },
  // { href: "/models", label: "Models" },
  // { href: "/pricing", label: "Pricing" },
  // { href: "/contact", label: "Contact Us" },
];

export const DropDownIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.6925 7.94229L10.4425 14.1923C10.3845 14.2504 10.3156 14.2965 10.2397 14.328C10.1638 14.3594 10.0825 14.3756 10.0003 14.3756C9.91821 14.3756 9.83688 14.3594 9.76101 14.328C9.68514 14.2965 9.61621 14.2504 9.55816 14.1923L3.30816 7.94229C3.19088 7.82502 3.125 7.66596 3.125 7.5001C3.125 7.33425 3.19088 7.17519 3.30816 7.05792C3.42544 6.94064 3.5845 6.87476 3.75035 6.87476C3.9162 6.87476 4.07526 6.94064 4.19253 7.05792L10.0003 12.8665L15.8082 7.05792C15.8662 6.99985 15.9352 6.95378 16.011 6.92236C16.0869 6.89093 16.1682 6.87476 16.2503 6.87476C16.3325 6.87476 16.4138 6.89093 16.4897 6.92236C16.5655 6.95378 16.6345 6.99985 16.6925 7.05792C16.7506 7.11598 16.7967 7.18492 16.8281 7.26079C16.8595 7.33666 16.8757 7.41798 16.8757 7.5001C16.8757 7.58223 16.8595 7.66354 16.8281 7.73941C16.7967 7.81528 16.7506 7.88422 16.6925 7.94229Z"
      fill="#222222"
    />
  </svg>
);

export const HamburgerIcon = ({ isOpen }) =>
  isOpen ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12.0001 10.7275L16.4551 6.27246L17.7277 7.54506L13.2727 12.0001L17.7277 16.4551L16.4551 17.7277L12.0001 13.2727L7.54506 17.7277L6.27246 16.4551L10.7275 12.0001L6.27246 7.54506L7.54506 6.27246L12.0001 10.7275Z"
        fill="#0E121B"
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
    >
      <path
        d="M1 11H15M1 6H15M1 1H15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

export const LinkedIn = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

export const IG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.13243 0.888328C7.10993 0.843328 7.4216 0.833328 9.9116 0.833328C12.4016 0.833328 12.7133 0.844162 13.6899 0.888328C14.6666 0.932495 15.3333 1.08833 15.9166 1.31416C16.5274 1.54499 17.0816 1.90583 17.5399 2.37249C18.0066 2.82999 18.3666 3.38333 18.5966 3.99499C18.8233 4.57833 18.9783 5.24499 19.0233 6.21999C19.0683 7.19916 19.0783 7.51083 19.0783 9.99999C19.0783 12.49 19.0674 12.8017 19.0233 13.7792C18.9791 14.7542 18.8233 15.4208 18.5966 16.0042C18.3666 16.6159 18.006 17.1702 17.5399 17.6283C17.0816 18.095 16.5274 18.455 15.9166 18.685C15.3333 18.9117 14.6666 19.0667 13.6916 19.1117C12.7133 19.1567 12.4016 19.1667 9.9116 19.1667C7.4216 19.1667 7.10993 19.1558 6.13243 19.1117C5.15743 19.0675 4.49077 18.9117 3.90743 18.685C3.2957 18.455 2.74145 18.0944 2.28327 17.6283C1.81692 17.1706 1.45603 16.6166 1.22577 16.005C0.999934 15.4217 0.844934 14.755 0.799934 13.78C0.754934 12.8008 0.744934 12.4892 0.744934 9.99999C0.744934 7.50999 0.755767 7.19833 0.799934 6.22166C0.844101 5.24499 0.999934 4.57833 1.22577 3.99499C1.45637 3.3834 1.81753 2.82942 2.2841 2.37166C2.74163 1.90541 3.29533 1.54453 3.9066 1.31416C4.48993 1.08833 5.1566 0.933328 6.1316 0.888328H6.13243ZM13.6158 2.53833C12.6491 2.49416 12.3591 2.48499 9.9116 2.48499C7.4641 2.48499 7.1741 2.49416 6.20743 2.53833C5.31327 2.57916 4.82827 2.72833 4.50493 2.85416C4.07743 3.02083 3.7716 3.21833 3.45077 3.53916C3.14664 3.83504 2.91258 4.19523 2.76577 4.59333C2.63993 4.91666 2.49077 5.40166 2.44993 6.29583C2.40577 7.26249 2.3966 7.55249 2.3966 9.99999C2.3966 12.4475 2.40577 12.7375 2.44993 13.7042C2.49077 14.5983 2.63993 15.0833 2.76577 15.4067C2.91243 15.8042 3.1466 16.165 3.45077 16.4608C3.7466 16.765 4.10743 16.9992 4.50493 17.1458C4.82827 17.2717 5.31327 17.4208 6.20743 17.4617C7.1741 17.5058 7.46327 17.515 9.9116 17.515C12.3599 17.515 12.6491 17.5058 13.6158 17.4617C14.5099 17.4208 14.9949 17.2717 15.3183 17.1458C15.7458 16.9792 16.0516 16.7817 16.3724 16.4608C16.6766 16.165 16.9108 15.8042 17.0574 15.4067C17.1833 15.0833 17.3324 14.5983 17.3733 13.7042C17.4174 12.7375 17.4266 12.4475 17.4266 9.99999C17.4266 7.55249 17.4174 7.26249 17.3733 6.29583C17.3324 5.40166 17.1833 4.91666 17.0574 4.59333C16.8908 4.16583 16.6933 3.85999 16.3724 3.53916C16.0765 3.23505 15.7164 3.001 15.3183 2.85416C14.9949 2.72833 14.5099 2.57916 13.6158 2.53833ZM8.74077 12.8258C9.39465 13.098 10.1227 13.1348 10.8007 12.9298C11.4787 12.7248 12.0644 12.2908 12.4579 11.7019C12.8515 11.113 13.0283 10.4057 12.9583 9.70091C12.8883 8.99611 12.5758 8.33747 12.0741 7.83749C11.7543 7.51789 11.3676 7.27317 10.9419 7.12095C10.5161 6.96873 10.062 6.91279 9.61201 6.95717C9.16207 7.00155 8.72756 7.14514 8.33977 7.3776C7.95198 7.61006 7.62055 7.92561 7.36935 8.30154C7.11815 8.67746 6.95342 9.1044 6.88703 9.55163C6.82064 9.99885 6.85423 10.4552 6.98538 10.8879C7.11654 11.3206 7.342 11.7188 7.64553 12.0539C7.94907 12.389 8.32312 12.6526 8.74077 12.8258ZM6.57993 6.66833C7.01745 6.23081 7.53687 5.88375 8.10852 5.64696C8.68016 5.41018 9.29285 5.28831 9.9116 5.28831C10.5303 5.28831 11.143 5.41018 11.7147 5.64696C12.2863 5.88375 12.8057 6.23081 13.2433 6.66833C13.6808 7.10585 14.0278 7.62526 14.2646 8.19691C14.5014 8.76856 14.6233 9.38125 14.6233 9.99999C14.6233 10.6187 14.5014 11.2314 14.2646 11.8031C14.0278 12.3747 13.6808 12.8941 13.2433 13.3317C12.3597 14.2153 11.1612 14.7117 9.9116 14.7117C8.66198 14.7117 7.46355 14.2153 6.57993 13.3317C5.69632 12.448 5.19991 11.2496 5.19991 9.99999C5.19991 8.75038 5.69632 7.55194 6.57993 6.66833ZM15.6683 5.98999C15.7767 5.88772 15.8635 5.76473 15.9235 5.62831C15.9836 5.49188 16.0156 5.3448 16.0178 5.19577C16.02 5.04674 15.9922 4.89878 15.9362 4.76067C15.8801 4.62256 15.797 4.49709 15.6916 4.39169C15.5862 4.2863 15.4607 4.20313 15.3226 4.14709C15.1845 4.09106 15.0365 4.06331 14.8875 4.06548C14.7385 4.06765 14.5914 4.09971 14.455 4.15974C14.3185 4.21978 14.1955 4.30657 14.0933 4.41499C13.8944 4.62585 13.7855 4.90593 13.7897 5.19577C13.7939 5.48561 13.9109 5.76239 14.1159 5.96736C14.3209 6.17233 14.5976 6.28935 14.8875 6.29358C15.1773 6.2978 15.4574 6.1889 15.6683 5.98999Z"
      fill="white"
    />
  </svg>
);

export const X = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
  </svg>
);

export const FB = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
  </svg>
);
